(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["entrupy-real-certificate-preview"] && !Shopify.designMode) return;
  try {
    (function () {
    function findIncludesList(root) {
      var labels = root.querySelectorAll('strong, b');
      for (var index = 0; index < labels.length; index += 1) {
        if (!/^includes\s*:/i.test(labels[index].textContent.trim())) continue;
        var heading = labels[index].closest('p') || labels[index].parentElement;
        var candidate = heading ? heading.nextElementSibling : null;
        while (candidate && candidate.tagName !== 'UL' && candidate.tagName !== 'OL') candidate = candidate.nextElementSibling;
        if (candidate) return candidate;
      }
      return null;
    }
    function certificateCandidates(root, description) {
      var values = [];
      var explicitId = (root.dataset.entrupyId || '').trim().toUpperCase();
      if (explicitId) values.push(explicitId);
      var descriptionCopy = description.cloneNode(true);
      descriptionCopy.querySelectorAll('[data-alb-real-certificate]').forEach(function (element) { element.remove(); });
      var text = descriptionCopy.textContent || '';
      var explicitMatch = text.match(/entrupy\s*(?:id|code|number|no\.?)\s*[:#]?\s*([A-Z0-9]{5,32})/i);
      if (explicitMatch) values.push(explicitMatch[1].toUpperCase());
      for (var match of text.matchAll(/\(([A-Z0-9]{5,32})\)/gi)) values.push(match[1].toUpperCase());
      return values.filter(function (value, index, array) { return /^[A-Z0-9]{5,32}$/.test(value) && array.indexOf(value) === index; });
    }
    async function resolveCertificate(root, description) {
      var candidates = certificateCandidates(root, description);
      for (var index = 0; index < candidates.length; index += 1) {
        try {
          var response = await fetch(root.dataset.certificateEndpoint + '/' + encodeURIComponent(candidates[index]));
          if (!response.ok) continue;
          var certificate = await response.json();
          if (certificate.entrupyId !== candidates[index] || !certificate.result?.final || !certificate.certificate?.preview) continue;
          return certificate;
        } catch (error) {}
      }
      return null;
    }
    function loadCertificateImage(image, source) {
      return new Promise(function (resolve, reject) {
        var settled = false;
        function finish() {
          if (settled) return;
          settled = true;
          image.removeEventListener('load', finish);
          image.removeEventListener('error', fail);
          if (typeof image.decode !== 'function') {
            resolve();
            return;
          }
          image.decode().then(resolve).catch(resolve);
        }
        function fail() {
          if (settled) return;
          settled = true;
          image.removeEventListener('load', finish);
          image.removeEventListener('error', fail);
          reject(new Error('Certificate image failed to load'));
        }
        image.addEventListener('load', finish, { once: true });
        image.addEventListener('error', fail, { once: true });
        image.src = source;
        if (image.complete && image.naturalWidth) finish();
      });
    }
    function animateCertificate(surface) {
      surface.classList.remove('is-opening');
      void surface.offsetWidth;
      requestAnimationFrame(function () { surface.classList.add('is-opening'); });
    }
    function initializeCertificate(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      var description = root.closest('.rte');
      var includesList = description ? findIncludesList(description) : null;
      var template = root.querySelector('[data-alb-certificate-lines]');
      var dialog = root.querySelector('[data-alb-cert-dialog]');
      if (!description || !includesList || !template || !dialog || typeof dialog.showModal !== 'function') return;
      var candidates = certificateCandidates(root, description);
      if (!candidates.length) return;
      var fragment = template.content.cloneNode(true);
      var certificateLine = fragment.querySelector('[data-alb-cert-line]');
      var image = root.querySelector('[data-alb-cert-preview]');
      var compressedPreviews = {};
      try { compressedPreviews = JSON.parse(root.dataset.certificatePreviews || '{}'); } catch (error) {}
      // Verify metadata early, but never download a hidden certificate image.
      var certificatePromise = resolveCertificate(root, description);
      var imagePromise = null;
      dialog.dataset.certificateState = 'loading';
      includesList.classList.add('alb-entrupy-real-list');
      includesList.insertBefore(fragment, includesList.firstChild);
      root.hidden = false;
      var surface = root.querySelector('[data-alb-cert-surface]');
      var lastTrigger = null;
      var trigger = certificateLine.querySelector('[data-alb-cert-trigger]');
      trigger.addEventListener('click', function () {
        lastTrigger = trigger;
        dialog.dataset.presentation = trigger.dataset.albCertTreatment;
        if (!dialog.open) {
          dialog.showModal();
          dialog.scrollTop = 0;
          document.body.classList.add('alb-cert-dialog-open');
        }
        if (dialog.dataset.certificateState === 'ready') {
          animateCertificate(surface);
          return;
        }
        if (imagePromise) return;
        dialog.dataset.certificateState = 'loading';
        imagePromise = certificatePromise.then(async function (certificate) {
          if (!certificate) return;
          var originalPreview = certificate.certificate.preview;
          var compressedPreview = compressedPreviews[certificate.entrupyId];
          if (compressedPreview) {
            try { await loadCertificateImage(image, compressedPreview); }
            catch (error) { await loadCertificateImage(image, originalPreview); }
          } else {
            await loadCertificateImage(image, originalPreview);
          }
          image.width = image.naturalWidth;
          image.height = image.naturalHeight;
          dialog.dataset.certificateShape = image.naturalWidth > image.naturalHeight ? 'landscape' : 'portrait';
          dialog.dataset.certificateState = 'ready';
          if (dialog.open) animateCertificate(surface);
        }).catch(function () {
          // Allow another click to retry. The verified official link remains usable.
          imagePromise = null;
          dialog.dataset.certificateState = 'failed';
          if (dialog.open) dialog.close();
        });
      });
      root.querySelector('[data-alb-cert-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.preventDefault(); dialog.close(); } });
      dialog.addEventListener('close', function () {
        document.body.classList.remove('alb-cert-dialog-open');
        surface.classList.remove('is-opening');
        if (lastTrigger) lastTrigger.focus();
      });
      certificatePromise.then(function (certificate) {
        if (!certificate) throw new Error('Certificate could not be verified');
        root.querySelector('[data-alb-cert-link]').href = certificate.certificate.site;
      }).catch(function () {
        dialog.dataset.certificateState = 'failed';
        if (dialog.open) dialog.close();
        certificateLine.remove();
        if (!includesList.querySelector('[data-alb-cert-line]')) includesList.classList.remove('alb-entrupy-real-list');
        root.hidden = true;
      });
    }
    function initializeAll(root) { (root || document).querySelectorAll('[data-alb-real-certificate]').forEach(initializeCertificate); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
    else initializeAll(document);
    document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
